export default "__VITE_ASSET__DRoVBtGX__"